// Conversion events for GTM, GA4, and the Meta pixel. Never throws.

import { ADS_CONVERSIONS, trackAdsConversion } from "./adsConversions";

function trackAds(sendTo, params) {
  if (typeof sendTo !== "string" || !sendTo.includes("/")) return;
  trackAdsConversion(sendTo, params);
}

export function trackEvent(name, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch (_) {}
}

export function trackMeta(eventName, params = {}) {
  try {
    if (typeof window.fbq === "function") window.fbq("track", eventName, params);
  } catch (_) {}
}

function once(key, fire) {
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch (_) {
    // If storage is blocked, still fire. A duplicate is better than silence.
  }
  fire();
}

export function trackSignUp({ method, userType, email }) {
  const guard = `aws_sign_up:${userType}:${email || method}`;
  once(guard, () => {
    trackEvent("sign_up", { method, user_type: userType });
    trackMeta("CompleteRegistration", { content_name: userType });
    trackAds(ADS_CONVERSIONS.SIGN_UP);
  });
}

export function rememberPendingPurchase(details) {
  try {
    sessionStorage.setItem("aws_pending_purchase", JSON.stringify(details));
  } catch (_) {}
}

export function readPendingPurchase() {
  try {
    const raw = sessionStorage.getItem("aws_pending_purchase");
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function trackPurchase({ transactionId, value, currency, itemName, itemCategory }) {
  if (!transactionId) return;
  once(`aws_purchase:${transactionId}`, () => {
    trackEvent("purchase", {
      transaction_id: transactionId,
      value,
      currency,
      items: [{ item_name: itemName || "credits", item_category: itemCategory || "topup" }],
    });
    trackMeta("Purchase", { value, currency });
    trackAds(ADS_CONVERSIONS.PURCHASE, {
      value,
      currency,
      transaction_id: transactionId,
    });
  });
}
